import React, { useState, useEffect, useCallback } from 'react';
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "../routes";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import { useCookies } from 'react-cookie';

// authen
import Signin from "./authenticate/Signin";
import Signup from "./authenticate/Signup";
import ForgotPassword from "./authenticate/ForgotPassword";
import ResetPassword from "./authenticate/ResetPassword";
import ServerError from "./authenticate/ServerError";

// trang chủ
import Overview from "./dashboard/DashboardOverview";
import { checkToken } from '../controller/api/auth';
import { messaging } from '../firebase';
import { getToken } from 'firebase/messaging';
import ShipSidebar from '../components/ShipSidebar';

import ShipCartWaiting from './ship/cart/waiting';
import ShipCartDone from './ship/cart/done';

import ShipTicketWaiting from './ship/ticket/waiting';
import ShipTicketDone from './ship/ticket/done';

import Banner from './banner';
import BannerGroup from './banner_group';

import MBDoisoat from './wip/mb-doisoat/MBDoisoat';
import { postApi } from '../controller/api/get';
import { API_CODE } from '../controller/api/constants';

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => (<> <Preloader show={loaded ? false : true} /> <Component {...props} /> </>)} />
  );
};

const RouteWithShipSidebar = ({ component: Component, ...rest }) => {

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <ShipSidebar />

        <main className="content">
          <Navbar />
          <Component {...props} region={rest.region || ''} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

export default () => {
  const [cookies] = useCookies(['wvivu']);

  const history = useHistory()

  const checkTokenFunc = useCallback(async () => {
    if (!cookies.wvivu) {
      history.replace(Routes.Signin.path)
    } else {
      const response = await checkToken(cookies.wvivu)

      if (response.status === 'success') {
        if (history.location.pathname.includes(Routes.Signin.path)) {
          history.replace(Routes.Overview.path)

        } else if (history.location.pathname === Routes.Overview.path) {
          history.replace(Routes.Overview.path)
        }
      } else {
        history.replace(Routes.Signin.path)
      }
    }
  }, [cookies.wvivu, history])

  useEffect(() => {
    checkTokenFunc()
  }, [checkTokenFunc])

  useEffect(() => {
    if (cookies.wvivu) {
      getToken(messaging, {
        vapidKey: 'BHzNmDUfGZzfLVHFJxRPOLUatfG-NZFWsPlPIbFjYpGbzWK3H2bjBbT5Ff11GTKQaEr92Qqs9qaHL4dTOA-251Q'
      }).then((currentToken) => {
        console.log('kdddd', currentToken)
        const requestData = {
          token: currentToken,
        }
        postApi(cookies.wvivu, API_CODE.POST_ADD_ADMIN_TOKEN, requestData)
      }).catch((e) => {
        alert(e)
      })
    }
  }, [cookies.wvivu])

  return (
    <Switch>
      {/* authen */}
      <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
      <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
      <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
      <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
      <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} />

      {/* trang chủ */}
      <Route exact path={Routes.Overview.path} component={Overview} />
      <RouteWithShipSidebar exact path={Routes.CartWaiting.path} component={ShipCartWaiting} />
      <RouteWithShipSidebar exact path={Routes.CartDone.path} component={ShipCartDone} />
      <RouteWithShipSidebar exact path={Routes.TicketWaiting.path} component={ShipTicketWaiting} />
      <RouteWithShipSidebar exact path={Routes.TicketDone.path} component={ShipTicketDone} />
      <RouteWithShipSidebar exact path={Routes.Banner.path} component={Banner} />
      <RouteWithShipSidebar exact path={Routes.BannerGroup.path} component={BannerGroup} />

      <RouteWithShipSidebar exact path={Routes.MBDoisoat.path} component={MBDoisoat} />

      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
}
